export const VIEW_SEARCH_GROUP = "views";
export const PROJECT_SEARCH_GROUP = "projects";
export const TASK_SEARCH_GROUP = "tasks";
